import React from "react";
import { Eye } from "lucide-react";
import { Badge, Card } from "../../components/AdminSharedComponents";

const ReportItem = ({ report, onOpenReportModal }) => {
  return (
    <Card
      className="cursor-pointer group/report"
      onClick={() => onOpenReportModal(report)}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="flex-1 min-w-0">
          <h5 className="font-medium text-gray-900 truncate group-hover/report:text-primary transition-colors">
            {report.title}
          </h5>

          <p className="text-sm text-gray-600 line-clamp-2 mt-1">
            {report.description}
          </p>

          <div className="flex items-center gap-2 mt-2">
            <span className="text-xs text-gray-500">
              {new Date(report.created_at).toLocaleDateString()}
            </span>

            {report.status && (
              <Badge variant="secondary" size="sm">
                {report.status}
              </Badge>
            )}
          </div>
        </div>

        <div className="flex items-center gap-1 text-gray-400 group-hover/report:text-primary transition-colors flex-shrink-0">
          <Eye className="h-4 w-4" />
          <span className="text-sm font-medium">Show Report</span>
        </div>
      </div>
    </Card>
  );
};

export default ReportItem;
